import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { formatCurrency } from '../../../../helpers/numbers'

import { selectedDV360AdAccountSelector } from '../../../../modules/selectors/adAccounts'

const BudgetSectionPreview = ({ campaign }) => {
  const { t } = useTranslation()

  const { currency_symbol } = useSelector(selectedDV360AdAccountSelector)

  const { budget_lifetime: initialBudgetLifetime } = campaign

  const formattedLifetimeBudget = formatCurrency(initialBudgetLifetime, { min: 2, max: 2 }, { symbol: currency_symbol })

  return (
    <p>
      {formattedLifetimeBudget} ({t('Lifetime')})
    </p>
  )
}

export default BudgetSectionPreview
